import { render, staticRenderFns } from "./DashboardViewEditing.vue?vue&type=template&id=fe450b4c"
import script from "./DashboardViewEditing.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports